<template>
<!--    <transition name="page-custom" mode="out-in" :key="$router.currentRoute.fullPath">-->
        <div class="mt-3">
                <router-view />
        </div>
<!--    </transition>-->
</template>

<script>
    import UIConstants from "../../../store/ui/constants";

    export default {
        name: "BaseAnimal",
        methods: {
            onMount() {
                const boundaries = document.getElementsByClassName('content-wrapper')[0].getBoundingClientRect();
                this.$store.dispatch(UIConstants.UIActions.UI_CONTEXT_MENU_CONTAINER_SET_BOUNDARIES, { boundaries: boundaries })
            }
        },
        mounted() {
            this.onMount();
        }
    }
</script>

<style scoped lang="scss">

</style>